<template>
    <svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore -->
        <path
            d="M17.313 8.9c.252 0 .496.084.696.238l7.474 5.766c.345.267.55.65.603 1.052.053.404-.046.828-.311 1.176l-7.792 5.75a1.143 1.143 0 0 1-1.599-.261 1.173 1.173 0 0 1-.219-.684v-1.718l-1.602.01c-3.522.032-4.725.273-7.565 1.903-.375.254-.64.382-.87.383 0-2.844.976-5.634 2.845-7.704 1.658-1.836 4.028-3.09 7.19-3.096l.002-1.652c0-.322.129-.614.339-.825.207-.208.493-.338.81-.338Z"
            stroke="currentColor"
            stroke-width="1.8"
            fill="none"
            fill-rule="evenodd"
        />
    </svg>
</template>
